import { LinkButton, P, theme } from '@salecycle/ui-component-library';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import LoginFormHeader from './loginFormHeader';
import { SubmitContainer } from './styles';

interface Props {
  changeState: (state: string, data?: any, emailAddress?: string) => void;
}

export const TermsAndConditions: FC<Props> = ({ changeState }) => {
  const { t } = useTranslation('common');
  const handleBackToSignIn = () => {
    changeState('signIn');
  };

  return (
    <>
      <LoginFormHeader
        color={theme.designToken.newPrimary}
        heading={t('authenticator.termsAndConditions.header')}
        description1=""
        description2=""
      />
      <P color={theme.designToken.newPrimary}> {t('authenticator.termsAndConditions.firstParagraph')}</P>
      <P color={theme.designToken.newPrimary}> {t('authenticator.termsAndConditions.secondParagraph')}</P>
      <P color={theme.designToken.newPrimary}> {t('authenticator.termsAndConditions.thirdParagraph')}</P>
      <P color={theme.designToken.newPrimary}> {t('authenticator.termsAndConditions.fourthParagraph')}</P>
      <SubmitContainer>
        <LinkButton
          color={theme.designToken.newPrimary}
          hoverColor={theme.designToken.newSecondary}
          onClick={handleBackToSignIn}
          underline
          hoverUnderline
          bold
        >
          {t('authenticator.linkButton.label')}
        </LinkButton>
      </SubmitContainer>
    </>
  );
};
export default TermsAndConditions;
